import { motion } from "framer-motion";
import { useLang } from "../../lib/i18n";
import { useSiteImage } from "../../hooks/useSettings";

const PHOTOS_KEYS = ["01", "02", "03"];

export const ShopGallery = () => {
    const { t, tr, fs } = useLang();
    const img1 = useSiteImage("img_gallery_1", "/assets/shop/shop-1.jpg");
    const img2 = useSiteImage("img_gallery_2", "/assets/shop/shop-2.jpg");
    const img3 = useSiteImage("img_gallery_3", "/assets/shop/shop-3.jpg");
    const photos = [
        { src: img1, tag: PHOTOS_KEYS[0] },
        { src: img2, tag: PHOTOS_KEYS[1] },
        { src: img3, tag: PHOTOS_KEYS[2] },
    ];

    return (
        <section id="gallery" className="relative py-24 sm:py-32 bg-[#0C1634] border-t border-white/5">
            <div className="max-w-7xl mx-auto px-4 sm:px-6">
                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-80px" }}
                    transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
                    className="mb-12 flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6"
                >
                    <div>
                        <p className="font-mono-spec text-xs tracking-[0.3em] text-amber-400 mb-3" dir="ltr">
                            {t("gal_eyebrow")}
                        </p>
                        <h2 className={`font-display font-extrabold text-2xl sm:text-3xl lg:text-4xl text-white ${fs("gal_title")}`}>
                            {t("gal_title")}
                        </h2>
                    </div>
                    <p className={`text-slate-400 text-base max-w-md ${fs("gal_desc")}`}>
                        {t("gal_desc")}
                    </p>
                </motion.div>

                <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5" data-testid="shop-gallery">
                    {photos.map((p, i) => (
                        <motion.figure
                            key={p.src}
                            initial={{ opacity: 0, y: 40 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-60px" }}
                            transition={{ duration: 0.7, delay: i * 0.12, ease: [0.16, 1, 0.3, 1] }}
                            data-testid={`shop-photo-${i + 1}`}
                            className={`group relative rounded-3xl overflow-hidden border border-white/10 hover:border-amber-400/40 transition-colors duration-500 ${
                                i === 1 ? "lg:-translate-y-6" : ""
                            }`}
                        >
                            <img
                                src={p.src}
                                alt={tr.gal_caps[i]}
                                loading="lazy"
                                className="w-full h-[420px] object-cover transition-transform duration-700 group-hover:scale-105"
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-[#0A1228]/90 via-transparent to-transparent" />
                            <span className="absolute top-4 left-4 font-mono-spec text-xs text-amber-400 bg-black/60 backdrop-blur border border-amber-400/30 rounded-full px-3 py-1" dir="ltr">
                                {p.tag}
                            </span>
                            <figcaption className={`absolute bottom-4 right-4 left-4 font-display font-bold text-white text-sm ${fs("gal_caps")}`}>
                                {tr.gal_caps[i]}
                            </figcaption>
                        </motion.figure>
                    ))}
                </div>
            </div>
        </section>
    );
};
